module.exports = "<div class=\"infoLoader\">\n    <div class='logo_wrapper'>\n        <div class='partner_logo' ng-class=\"[logoClass]\"></div>\n    </div>\n    <div class=\"loader\">\n        <xo-card-loader\n            state=\"setbuyerProgress\"\n            auth=\"auth\"\n            message=\"{{cardLoaderMessage}}\"\n        ></xo-card-loader>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./pages/xo-login/tokenized-wallet-loader/template.html
// module id = ./pages/xo-login/tokenized-wallet-loader/template.html
// module chunks = main-code-split